import React from 'react';
import '../../css/Disclaimer.css'; // Adjusted path to import Disclaimer.css
const Disclaimer = () => {
    return (
        <div className="disclaimer-container">
            <h1>AI-Generated Content Disclaimer</h1>
            <p>
                This website uses artificial intelligence (AI) technologies to assist in generating certain documentation and content. While we make every effort to provide accurate and up-to-date information, AI-generated content may contain errors or inaccuracies, as it does not undergo the same review as content generated solely by licensed professionals.
            </p>
            <p>
                The AI-generated content on this site is provided for informational purposes only and is not a substitute for professional advice, diagnosis, or treatment. It is essential that users verify the information and consult qualified professionals before making any decisions based on AI-generated content.
            </p>
            <p>
                By using this site, you acknowledge and agree that reliance on AI-generated content is at your own risk. We disclaim all liability for any damages or losses that may arise from the use of, or reliance on, this content.
            </p>
            <p>
                If you have questions or concerns regarding the use of AI-generated content on this website, please contact <a href="mailto:affordable@medbossconsutling.com">Samatha</a>.
            </p>
        </div>
    );
};

export default Disclaimer;
